var CommentCountAction = React.createClass({
  getDefaultProps() {
    return {
      count: 0
    }
  },
  linkClicked(e) {
    e.preventDefault();
    RA.ViewKB.Comments.scrollTo();
  },
  render() {
    let label = this.props.count < 2 ? Labels.getLabel("Comment") : Labels.getLabel("Comments"),
      count = this.props.count < 1 ? "" : this.props.count + " ";

    return (
      <a href="#comments" className="actions-list__link -comment" onClick={this.linkClicked}>
        <span className="glyphicon glyphicon-comment actions-list__icon"></span>
        <span>{` ${count} ${label}`}</span></a>
    )
  }
});